<div id="upper-artwork-container" class="canvas-container">
  <div #bbvalueEle [ngClass]="bbvalue ? 'hovervalue':'hovervalueEmpty'">{{bbvalue}}</div>
  <div #imgContainer class="img-container" id="artwork-verify-container">
  </div>
</div>